import Box from '@mui/material/Box';
import { TextField, useFieldHelper } from 'framework/ui/field';
import { AccountLinkField } from 'domain/shared/account';
import { ArtifactStorageFileField } from 'domain/shared/artifactStorage';
import { ProjectLink, ProjectWeeklyReportLink } from 'domain/shared/project';
import { DataGridLayout, List, ListPageLayout } from 'framework/list';
import { LeadLinkField } from 'domain/shared/lead';

interface ArtifactRelationFieldProps {
  source: string;
}

const mapArtifactRelations = (info: any) => {
  const mappedRelation = {
    entityClass: info.entityClass,
    linkField: <></>,
  };

  switch (info.entityClass) {
    case 'Account':
      mappedRelation.linkField =
        info.entity?.accountName && info.entity?.accountId ? (
          <AccountLinkField
            idSource=""
            value={info.entity.accountName}
            idValue={info.entity.accountId}
            isInternal={false}
          />
        ) : (
          <>-</>
        );
      break;
    case 'ArtifactStorageFile':
      mappedRelation.entityClass = 'Artifact Storage File';
      mappedRelation.linkField = <ArtifactStorageFileField source="metaInformation" value={info.entity.artifact} />;
      break;
    case 'Project':
      mappedRelation.linkField = <ProjectLink isClickable name={info.entity.name} id={info.entity.id} />;
      break;
    case 'ProjectWeeklyReport':
      mappedRelation.entityClass = 'Project Weekly Report';
      mappedRelation.linkField = (
        <ProjectWeeklyReportLink
          isClickable
          fromDate={info.entity?.from}
          toDate={info.entity?.to}
          id={info.entityId}
          projectId={info.entity?.project.id}
        />
      );
      break;
    case 'Lead':
      mappedRelation.linkField = (
        <LeadLinkField idSource="" nameValue={info.entity.id} idValue={info.entity.id} isInternal={false} />
      );
      break;
    default:
      mappedRelation.linkField = <></>;
      break;
  }

  return mappedRelation;
};

const ArtifactRelationField = ({ source }: ArtifactRelationFieldProps) => {
  const { getValue } = useFieldHelper<any>({ source });
  const relations = getValue();

  return (
    <Box sx={{ '& .page-content': { minHeight: 'fit-content !important' } }}>
      <List
        getDataMethod={async () => {
          return Promise.resolve({ result: relations.map(mapArtifactRelations) });
        }}
      >
        <ListPageLayout sxPaper={{ p: 0 }}>
          <DataGridLayout showTotal={false} isSmallTable tableWrapperClassName="meta-info-table">
            <TextField source="entityClass" label="Entity related to" width={250} />
            <TextField source="linkField" label="Link" />
          </DataGridLayout>
        </ListPageLayout>
      </List>
    </Box>
  );
};

export default ArtifactRelationField;
